window.DASHBOARD_AREA_LIST = {
    options: {},
    init: function (options) {
        _.extend(window.DASHBOARD_AREA_LIST.options, options);
        window.DASHBOARD_AREA_LIST.initEventListeners();
    },
    initEventListeners: function () {
        Livewire.on('dashboardShowArea', function (area) {
            window.POLYGONS.showArea(area.id);
        });
        Livewire.on('dashboardHideArea', function (area) {
            window.POLYGONS.hideArea(area.id);
        });
    },
}
